/**
 * api接口统一管理
 */
// import axios from './http.js'
import maincount from './console/maincount.js'
import common from './console/common.js'
import login from './console/login.js'
import menu from './console/menu.js'
import admin from './console/admin.js'
import log from './console/log.js'
import role from './console/role.js'
import section from './console/section.js'
import config from './console/config.js'
import appVersionset from './console/appVersionset.js'
import adpos from './console/adpos.js'
import ad from './console/ad.js'
import tongbucompany from './console/tongbucompany.js'
//清单
import lists from './console/lists.js'
import listtype from './console/listtype.js'

// 单页
import pages from './console/pages.js'
import qrcodes from './console/qrcodes.js'
// 商城
import goods from './tm_good/goods.js'
import salegoods from './tm_good/salegoods.js'
import goodcate from './tm_good/goodcate.js'
import salegoodcate from './tm_good/salegoodcate.js'
import goodbrand from './tm_good/goodbrand.js'
import goodattr from './tm_good/goodattr.js'
import goodorder from './tm_good/goodorder.js'
import goodztorder from './tm_good/goodztorder.js'
import returnorder from './tm_good/returnorder.js'
import saleinvoice from './tm_good/saleinvoice.js'
import goodspec from './tm_good/goodspec.js'
import productprocess from './tm_good/productprocess.js'
// 提现
import applylog from './tm_consume/applylog.js'
// 匠人收费记录
import tradmoney from './tm_consume/tradmoney.js'
// 供应商记录
import sellermoney from './tm_consume/sellermoney.js'
// 快递列表
import logistics from './tm_good/logistics.js'
// 约看
import lives from './tm_lives/lives.js'
import livesorder from './tm_lives/livesorder.js'
import liveroomType from './tm_lives/liveroomType.js'//视频分类
import livestype from './tm_lives/livestype.js'//约看分类
// 用户管理
import user from './tmuser/user.js'
import usergroup from './tmuser/usergroup.js'
import userinvoice from './tmuser/userinvoice.js'
// 匠人
import tradesman from './tmuser/tradesman.js'
import tradesmancate from './tmuser/tradesmancate.js'
import tradesmanskill from './tmuser/tradesmanskill.js'
import tradesmansorce from './tmuser/tradesmansorce.js'
import tradesmanthumbcate from './tmuser/tradesmanthumbcate.js'
import tradesmanthumb from './tmuser/tradesmanthumb.js'
import tradesmanthumbcomment from './tmuser/tradesmanthumbcomment.js'
// 搜索
import searchdata from './console/searchdata.js'
// 专题
import special from './tm_special/special.js'
import specialtrad from './tm_special/specialtrad.js'

import intangibleCate from './tm_intangible/intangibleCate.js'
import itemtype from './tm_intangible/itemtype.js'
import intangibleLevel from './tm_intangible/intangibleLevel.js'
import intangibleItem from './tm_intangible/intangibleItem.js'
import area from './tm_intangible/area.js'
import intangibleLocation from './tm_intangible/intangibleLocation.js'
import locationErrors from './tm_intangible/locationErrors.js'
import locationComments from './tm_intangible/locationComments.js'
import noteConfig from './tm_chargeCard/noteConfig.js'
import locationNote from './tm_chargeCard/locationNote.js'
// 员工分组
import staffGroup from './tm_chargeCard/staffGroup.js'
import staff from './tm_chargeCard/staff.js'
import chargecard from './tm_chargeCard/chargecard.js'
// 商家后台
import merchantMenu from './tm_trade_manage/menu.js'
import merchantRole from './tm_trade_manage/role.js'

// 供应商
import seller from './tmuser/seller.js'
import agents from './tmuser/agents.js'
import partners from './tmuser/partners.js'

// 园区
import park from './tmuser/park.js'
// 园区收入明细
import parkmoneylog from './tm_consume/parkmoneylog.js'

//直播
import liveroom from './tm_liveroom/liveroom.js'

//exceL导出
import excelExport from './console/excelExport.js'

// 快递列表
// import logisticlist from './tm_good/logisticlist.js'

//视频
import livevideos from './tm_liveroom/livevideos.js'
import liveVideosChapter from './tm_liveroom/livevideoschapter.js'
import liveVideosOrder from './tm_liveroom/livesvideoorder.js'

//定制
import custommadecate from './tm_customized/custommadecate.js'
import custommade from './tm_customized/custommade.js'
import madeorder from './tm_customized/madeorder.js'
import customcommunity from './tm_customized/customcommunity.js'
import customcomment from './tm_customized/customcomment.js'

//头条推荐类型
import headlinepush from './tm_headline/headlinepush.js'
//头条分类
import headlinecate from './tm_headline/headlinecate.js'
//头条
import headline from './tm_headline/headline.js'
//历史的今天分类
import historycate from './tm_history_today/historycate.js'
//历史的今天
import history from './tm_history_today/history.js'
//历史的今天道具
import historydaoju from './tm_history_today/historydaoju.js'
//海报
import poster from './tm_history_today/poster.js'
//漂流
import lovedrift from './tm_history_today/lovedrift.js'

import firstagent from './tmuser/firstagent.js'
import salesman from './tmuser/salesman.js'
import tongbupoints from './tmuser/tongbupoints.js'
//融宝申请
import reaplyapply from './reapal/apply.js'

// 系统消息
import sysmsg from './tm_msg/systemmsg.js'
// 客服消息
import customermsg from './tm_msg/customermsg.js'
//举报
import report from './tm_msg/report.js'

//献礼
import xlisupportunit from './tm_xianli/xlisupportunit.js'
import xlilinks from './tm_xianli/xlilinks.js'
import xliarticle from './tm_xianli/xliarticle.js'

//匠人资讯
import tradesmanInformation from './tm_trade_manage/tradesmanInformation.js'
//智慧园区
import ticketcollector from './tm_smartpark/ticketcollector.js'
import smartpark from './tm_smartpark/smartpark.js'
import smartvenue from './tm_smartpark/smartvenue.js'
import smartorder from './tm_smartpark/smartorder.js'
import smarttickettype from './tm_smartpark/smarttickettype.js'//智慧票务分类
import smartticket from './tm_smartpark/smartticket.js'//票
import smartthroughticket from './tm_smartpark/smartthroughticket.js'//通票
import smartticketprice from './tm_smartpark/smartticketprice.js'//票价
import smartreceper from './tm_smartpark/smartreceper.js'//接待员
import smartTimesCard from './tm_smartpark/smartTimesCard.js'//次卡
import smartenterinfoset from './tm_smartpark/smartenterinfoset.js'//配置
import smartservice from './tm_smartpark/smartservice.js'//附加服务
import teamtype from './tm_smartpark/teamtype.js'//团队类型
import studygroup from './tm_smartpark/studygroup.js'//研学人群
import studycontent from './tm_smartpark/studycontent.js'//研学内容
import venueproduct from './tm_smartpark/venueproduct.js'//场馆产品
import screen from './tm_smartpark/screen.js'
import bigmap from './tm_intangible/bigmap.js'
import appVersion from './tm_smartpark/appVersion.js'//app版本管理
//盲盒
import productpool from './tm_manghe/productpool.js'//产品池
import productpoolcate from './tm_manghe/productpoolcate.js'//产品池
import data from './tm_manghe/data.js'//材料仓库
import productpoolgood from './tm_manghe/productpoolgood.js'//产品池合成商品
import productpoolprobability from './tm_manghe/productpoolprobability.js'//产品池属性
import hechengpoolgood from './tm_manghe/hechengpoolgood.js'//材料合成池商品
import hechengpooldata from './tm_manghe/hechengpooldata.js'//材料合成池材料
import goodattrtag from './tm_manghe/goodattrtag.js'//商品属性标签
import hechengpoolprobability from './tm_manghe/hechengpoolprobability.js'//材料合成池属性
import mangheorder from './tm_manghe/mangheorder.js'//商品订单
import winner from './tm_manghe/winner.js'//中奖者
//盲盒营销
import manghecolor from './tm_manghe/made/manghecolor.js'//配色
import mangheset from './tm_manghe/made/mangheset.js'//配置
import manghewish from './tm_manghe/made/manghewish.js'//祝福
import manghemadeorder from './tm_manghe/made/manghemadeorder.js'//盲盒定制订单
import manghecolors from './tm_manghe/manghecolors.js'//首页等配色
import notice from './tm_manghe/notice.js'//公告
//盲盒商城
import mangheshopgoodcate from './tm_manghe/shop/goodcate.js'//商品分类
import mangheshopgoods from './tm_manghe/shop/goods.js'//商品
import mangheshopgoodorder from './tm_manghe/shop/goodorder.js'//商品订单
import mangheshopgoodreturnorder from './tm_manghe/shop/goodreturnorder.js'//商品退款订单
import mangheshopgoodspec from './tm_manghe/shop/goodspec.js'//商品规格
import mangheshopgoodkeyword from './tm_manghe/shop/goodkeyword.js'//商品推荐词
//百姓墙
import baixingqiangoperator from './tm_manghe/baixingqiang/operator.js'//运营商
// import mangheshopgoods from './tm_manghe/baixingqiang/goods.js'//幸运抽盒配置
import baixingqiangchouqurule from './tm_manghe/baixingqiang/chouqurule.js'//幸运抽盒规则
import baixingqiang from './tm_manghe/baixingqiang/baixingqiang.js'
import baixingqiangorder from './tm_manghe/baixingqiang/goodorder.js'
import mangheqianggoodreturnorder from './tm_manghe/baixingqiang/goodreturnorder.js'//商品退款订单
// 新专题
import zhuanti from './tm_zhuanti/index.js'
import zhuanticomment from './tm_zhuanti/zhuanticomment.js'

//数字产品
import numprocate from './tm_numpro/numprocate.js'
import product from './tm_numpro/product.js'
import showroom from './tm_numpro/showroom.js'
import collector from './tm_numpro/collector.js'
import collectionchain from './tm_numpro/collectionchain.js'
import collectionorder from './tm_numpro/collectionorder.js'
import numprotype from './tm_numpro/type.js'
import turnlog from './tm_numpro/turnlog.js'
import exchange from './tm_numpro/exchange.js'
import collectorrecord from './tm_numpro/collectorrecord.js'

// 媒资管理
import mediaCategory from "./console/mediaCategory";
import media from "./console/media";
import mediaShare from "./console/mediaShare";

const api = {
    zhuanti,
    zhuanticomment,
    tradesmanInformation,
    maincount,
    common,
    login,
    menu,
    admin,
    log,
    role,
    section,
    config,
    appVersionset,
    pages,
    qrcodes,
    excelExport,
    // 广告
    adpos,
    ad,
    tongbucompany,
    listtype,
    lists,
    // 商城
    goods,
    salegoods,
    goodcate,
    salegoodcate,
    goodbrand,
    goodattr,
    goodorder,
    goodztorder,
    returnorder,
    saleinvoice,
    logistics,
    goodspec,
    productprocess,

    // 用户
    user,
    usergroup,
    userinvoice,
    tradesman,
    tradesmancate,
    tradesmanskill,
    tradesmansorce,
    tradesmanthumbcate,
    tradesmanthumb,
    tradesmanthumbcomment,
    // 搜索
    seller,
    agents,
    partners,
    // 搜索
    searchdata,
    // 专题
    special,
    specialtrad,
    // 约看
    lives,
    // 约看订单
    livesorder,
    liveroomType,
    livestype,

    // 项目相关
    intangibleCate,
    itemtype,
    intangibleLevel,
    intangibleItem,
    area,
    intangibleLocation,
    locationErrors,
    locationComments,
    noteConfig,
    locationNote,
    // 员工分组
    staffGroup,
    staff,
    chargecard,
    // 商家后台
    merchantMenu,
    merchantRole,
    // 提现
    applylog,
    tradmoney,
    // 园区
    park,
    // 园区收入明细
    parkmoneylog,
    sellermoney,

    //直播
    liveroom,
    logistics,

    //视频
    livevideos,
    liveVideosChapter,
    liveVideosOrder,

    //定制
    custommadecate,
    custommade,
    madeorder,
    customcommunity,
    customcomment,
    //头条
    headlinepush,
    headlinecate,
    headline,
    //历史的今天
    historycate,
    history,
    historydaoju,
    poster,
    //漂流
    lovedrift,

    //一级分销商
    firstagent,
    salesman,
    tongbupoints,
    //融宝申请
    reaplyapply,
    // 系统消息
    sysmsg,
    // 客服消息
    customermsg,
    report,
    //献礼
    xlisupportunit,
    xlilinks,
    xliarticle,
    //智慧园区
    ticketcollector,
    smartpark,
    smartvenue,
    smartorder,
    smarttickettype,
    smartticket,
    smartticketprice,
    smartthroughticket,
    smartreceper,
    smartTimesCard,
    smartenterinfoset,
    smartservice,
    teamtype,
    studycontent,
    studygroup,
    venueproduct,
    screen,
    bigmap,
    appVersion,
    //盲盒
    productpool,
    productpoolcate,
    data,
    productpoolgood,
    productpoolprobability,
    hechengpoolgood,
    hechengpooldata,
    goodattrtag,
    hechengpoolprobability,
    mangheorder,
    winner,
    manghecolor,
    manghewish,
    mangheset,
    manghemadeorder,
    manghecolors,
    numprocate,
    product,
    showroom,
    collector,
    collectionchain,
    collectionorder,
    numprotype,
    turnlog,
    exchange,
    collectorrecord,

    mediaCategory,
    media,
    mediaShare,
    notice,
    //盲盒商城
    mangheshopgoodcate,
    mangheshopgoods,
    mangheshopgoodorder,
    mangheshopgoodreturnorder,
    mangheshopgoodspec,
    mangheshopgoodkeyword,
    baixingqiangoperator,
    baixingqiangchouqurule,
    baixingqiang,
    baixingqiangorder,
    mangheqianggoodreturnorder
}

export default api
